const COLORS = {
    primary: '#c7a05a',
    secondary: '#E9E4C8',
    primaryG: 'linear-gradient(205deg,#c7a05a,#cba665,#cfac6f,#d2b27a,#d6b885,#d9bf8f,#dcc59a,#dfcba5)',
    light: '#f3f3f3',
    white: '#F3F3F3',
    red: '#F35251',
  }
  
  export default COLORS;